module.exports = __webpack_public_path__ + "img/Sedex_logo.cbfbe147.png";